import * as React from "react"

export const CalendarDate = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24.64 22.73"
        xmlSpace="preserve"
        width="1em" height="1em" fill="currentColor"
    >
        <path
            d="M15.91 2.64h.25c.29.12.41.34.38.66-.01.2 0 .41 0 .62h1.48c.94.01 1.75.64 2 1.54.03.1.05.2.08.3v11.33c-.01.03-.03.07-.03.1-.17.99-1.03 1.74-2.04 1.74-4.05 0-8.1.01-12.15 0-1.13 0-2.07-.94-2.07-2.07V5.98c0-.87.57-1.65 1.39-1.94.38-.14.77-.12 1.16-.12h1.01c0-.22.01-.42 0-.62-.02-.32.1-.54.39-.66h.25c.29.12.41.34.39.65-.01.2 0 .41 0 .61h7.13c0-.21.01-.41 0-.61-.03-.31.09-.53.38-.65zm3.18 5.61H4.83V16.71c0 .77.44 1.2 1.2 1.2h11.85c.76 0 1.2-.44 1.2-1.2V8.44c.01-.07.01-.12.01-.19zm-2.55-3.32v.46c0 .32-.22.55-.51.55-.29 0-.5-.23-.51-.56v-.45H8.39v.43c0 .35-.21.58-.51.58-.3 0-.5-.23-.5-.57v-.44H5.93c-.55 0-1.01.37-1.07.92-.05.44-.01.9-.01 1.36h14.24V6.06c0-.06 0-.12-.01-.17-.06-.51-.46-.92-.96-.95-.52-.03-1.04-.01-1.58-.01z"
        />
    </svg>
)

